export default {
  en: {
    headerTitle: 'Tutor',
    startLevelCheck: 'Start the level check',
    startButton: 'Start conversation',
  },
  ru: {
    headerTitle: 'Собеседник',
    startLevelCheck: 'Начать проверку',
    startButton: 'Начать диалог',
  },
  de: {
    headerTitle: 'Tutor',
    startLevelCheck: 'Check starten',
    startButton: 'Dialog starten',
  },
  pt: {
    headerTitle: 'Tutor',
    startLevelCheck: 'Iniciar teste',
    startButton: 'Iniciar diálogo',
  },
  fr: {
    headerTitle: 'Tuteur',
    startLevelCheck: 'Commencer le test',
    startButton: 'Lancer le dialogue',
  },
  es: {
    headerTitle: 'Tutor',
    startLevelCheck: 'Empezar la prueba',
    startButton: 'Iniciar diálogo',
  },
};
